import { render, staticRenderFns } from "./PdpTabHints.vue?vue&type=template&id=cdb58678&scoped=true"
import script from "./PdpTabHints.vue?vue&type=script&lang=js"
export * from "./PdpTabHints.vue?vue&type=script&lang=js"
import style0 from "./PdpTabHints.vue?vue&type=style&index=0&id=cdb58678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb58678",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-tab-hints%2FPdpTabHints.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports